import { MANAGEMENT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { INTEGRATION_IMAGE } from "app/pages/sales-intelligence/pages/management/constants/constants";
import { MANAGE_INTEGRATION_ROUTE } from "app/pages/sales-intelligence/constants/sl_routes";
import { translate } from "app/filters/i18nFilter";

const emptyIntegrationStatusSyncConfig = {
    get title() {
        return translate("si.crm-integration.sync.status.empty.title");
    },
    imageName: "/images/sales-intelligence/empty-integration.svg",
};

const notIntegratedConfig = {
    get description() {
        return translate("si.crm-integration.sync.status.not-integrated.admin.description");
    },
    get btnLabel() {
        return translate("si.crm-integration.sync.status.btn.label.integrate");
    },
    linkTo: MANAGEMENT_ROUTE,
};

const notIntegratedUserConfig = {
    get description() {
        return translate("si.crm-integration.sync.status.not-integrated.user.description");
    },
    btnLabel: "",
    linkTo: "",
};

const notActiveAdminConfig = {
    get description() {
        return translate("si.crm-integration.sync.status.not-active.admin.description");
    },
    get btnLabel() {
        return translate("si.crm-integration.sync.status.btn.label.activate");
    },
    linkTo: MANAGEMENT_ROUTE,
};

const notActiveUserConfig = {
    get description() {
        return translate("si.crm-integration.sync.status.not-active.user.description");
    },
    btnLabel: "",
    linkTo: "",
};

export const crmIntegrationStatusSyncConfig = {
    salesforce: {
        get title() {
            return translate("si.crm-integration.sync.status.salesforce.title");
        },
        imageName: INTEGRATION_IMAGE.salesforce,
        admin: {
            get description() {
                return translate("si.crm-integration.sync.status.salesforce.admin.description");
            },
            get btnLabel() {
                return translate("si.crm-integration.sync.status.btn.label.activate");
            },
            linkTo: MANAGE_INTEGRATION_ROUTE.salesforce,
        },
        user: {
            get description() {
                return translate("si.crm-integration.sync.status.salesforce.user.description");
            },
            btnLabel: "",
            linkTo: "",
        },
    },
    hubspot: {
        get title() {
            return translate("si.crm-integration.sync.status.hubspot.title");
        },
        imageName: INTEGRATION_IMAGE.hubspot,
        admin: {
            get description() {
                return translate("si.crm-integration.sync.status.hubspot.admin.description");
            },
            get btnLabel() {
                return translate("si.crm-integration.sync.status.btn.label.activate");
            },
            linkTo: MANAGE_INTEGRATION_ROUTE.hubspot,
        },
        user: {
            get description() {
                return translate("si.crm-integration.sync.status.hubspot.user.description");
            },
            btnLabel: "",
            linkTo: "",
        },
    },
    notIntegratedCrm: {
        ...emptyIntegrationStatusSyncConfig,
        admin: notIntegratedConfig,
        user: notIntegratedUserConfig,
    },
    notIntegratedCrmWithOutTitle: {
        ...emptyIntegrationStatusSyncConfig,
        title: "",
        admin: notIntegratedConfig,
        user: notIntegratedUserConfig,
    },
    notActiveCrm: {
        ...emptyIntegrationStatusSyncConfig,
        admin: notActiveAdminConfig,
        user: notActiveUserConfig,
    },
    notActiveCrmWithOutTitle: {
        ...emptyIntegrationStatusSyncConfig,
        title: "",
        admin: notActiveAdminConfig,
        user: notActiveUserConfig,
    },
};
